import React from 'react';
import { jsPDF } from "jspdf";
import { Button} from 'reactstrap'

function PDFGenerator(props) {
    const onButtonClick = () => {
        console.log(props.data)
        console.log(props.startDate)
        console.log(props.endDate)
        var doc = new jsPDF();
        props.data.map(shiftItem =>{
            
            doc.setFontSize(22);
            doc.text(shiftItem.user.name, 20, 20);
            doc.setFontSize(16);
            doc.text("From " + props.startDate.toISOString().split('T')[0] + ' until ' + props.endDate.toISOString().split('T')[0], 20, 30);

            function createHeaders(keys) {
                let result = [];
                for (let i = 0; i < keys.length; i += 1) {
                  result.push({
                    id: keys[i],
                    name: keys[i],
                    prompt: keys[i],
                    width: 65,
                    align: "center",
                    padding: 0
                  });
                }
                return result;
            }

            let headers = createHeaders([
                'sTime',
                'ClockIn',
                'eTime',
                'ClockOut',
                'workedHours'
            ]);

            const fixedData = shiftItem.data.map((dayItem)=>{
                return {
                    sTime: dayItem.sTime ? new Date(Date.parse(new Date(dayItem.sTime)) + 60*60*1000).toISOString().split('.')[0].slice(0, -3) : 'N.A.',
                    ClockIn: dayItem.ClockIn ? new Date(Date.parse(new Date(dayItem.ClockIn)) + 60*60*1000).toISOString().split('.')[0].slice(0, -3) : 'N.A.',
                    eTime: dayItem.eTime ? new Date(Date.parse(new Date(dayItem.eTime)) + 60*60*1000).toISOString().split('.')[0].slice(0, -3) : 'N.A.',
                    ClockOut: dayItem.ClockOut ? new Date(Date.parse(new Date(dayItem.ClockOut)) + 60*60*1000).toISOString().split('.')[0].slice(0, -3) : 'N.A.',
                    workedHours: dayItem.workedHours ? dayItem.workedHours.toString() : 'N.A.'
                }
            })
            fixedData.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Total Hours:', workedHours:shiftItem.totals.hoursWorked ? shiftItem.totals.hoursWorked.toString() : ''})
            fixedData.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Payrate:', workedHours:shiftItem.user.payrate ? shiftItem.user.payrate.toString() + '€' : ''})
            shiftItem.user.contract && fixedData.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Bank Transfer:', workedHours:shiftItem.user.contract ? shiftItem.user.contract.toString() + '€' : ''})
            shiftItem.totals.rent && fixedData.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Rent:', workedHours:shiftItem.totals.rent ? shiftItem.totals.rent.toString() + '€' : ''})
            shiftItem.totals.deduction && fixedData.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:shiftItem.totals.reason ? shiftItem.totals.reason : '', workedHours:shiftItem.totals.deduction ? shiftItem.totals.deduction.toString() + '€' : ''})
            fixedData.push({
                sTime:'-',
                ClockIn:'-', 
                eTime:'-',
                ClockOut:'Total:', 
                workedHours: (Number(shiftItem.totals.hoursWorked) * shiftItem.user.payrate - shiftItem.user.contract - shiftItem.totals.rent - shiftItem.totals.deduction).toString() + '€' 
            })
            
            console.log(fixedData)
            doc.table(5, 42, fixedData, headers, { autoSize: true });
            doc.addPage("a4");


        })
        /** Last Page totals and average */
        
        doc.setFontSize(22);
        doc.text('Totals', 20, 20);
        doc.setFontSize(16);
        doc.text("From " + props.startDate.toISOString().split('T')[0] + ' until ' + props.endDate.toISOString().split('T')[0], 20, 30);

        function createHeaders(keys) {
            let result = [];
            for (let i = 0; i < keys.length; i += 1) {
              result.push({
                id: keys[i],
                name: keys[i],
                prompt: keys[i],
                width: 65,
                align: "center",
                padding: 0
              });
            }
            return result;
        }

        let headers = createHeaders([
            'Description',
            'Value',
        ]);

        let finalTotal = {
            hoursWorked : 0,
            averagePayRate : 0,
            averagePay : 0,
            total : 0
        }
        props.data.map(shiftItem=>{
            if(shiftItem.user.payrate == undefined) shiftItem.user.payrate = 0
            if(shiftItem.user.contract == undefined) shiftItem.user.contract = 0
            let tempTotal = Number(shiftItem.totals.hoursWorked) * Number(shiftItem.user.payrate) - Number(shiftItem.user.contract) - Number(shiftItem.totals.rent) - Number(shiftItem.totals.deduction)
            finalTotal.hoursWorked += Number(shiftItem.totals.hoursWorked)
            if(Number(shiftItem.user.payrate) != 0) finalTotal.averagePayRate == 0 ? finalTotal.averagePayRate = Number(shiftItem.user.payrate) : finalTotal.averagePayRate = (finalTotal.averagePayRate + Number(shiftItem.user.payrate)) / 2
            if(tempTotal != 0) finalTotal.averagePay == 0 ? finalTotal.averagePay = tempTotal : finalTotal.averagePay = (finalTotal.averagePay + tempTotal) / 2
            finalTotal.total += tempTotal
        })

        //calculate time difference  
        let time_difference = props.endDate.getTime() - props.startDate.getTime();  
  
        //calculate days difference by dividing total milliseconds in a day  
        let days_difference = time_difference / (1000 * 60 * 60 * 24);  

        finalTotal = [{
            Description : 'Hours Worked',
            Value: finalTotal.hoursWorked.toFixed(2).toString()
        },{
            Description : 'Average Pay Rate',
            Value: finalTotal.averagePayRate.toFixed(2).toString()
        },{
            Description : 'Average Pay',
            Value: finalTotal.averagePay.toFixed(2).toString()
        },{
            Description : 'Total Per Day',
            Value: (finalTotal.total / days_difference).toFixed(2).toString()
        },{
            Description : 'Total',
            Value: finalTotal.total.toFixed(2).toString()
        }]

        doc.table(5, 42, finalTotal, headers, { autoSize: true });

        doc.save("From " + props.startDate.toISOString().split('T')[0] + ' until ' + props.endDate.toISOString().split('T')[0] + ".pdf");
    };
  return (
        <Button onClick={onButtonClick} className='btn-info ml-4'>
            Download PDF
        </Button>
  )
}

export default PDFGenerator